module.exports = __webpack_public_path__ + "img/impressionen_punkte.59940406.jpg";